import { makeAutoObservable } from 'mobx';
import { QUOTE_ROUTES, QuoteRouteV2Id, RouteV2Id } from 'routes/routesConfigV2';
import EnrollmentPeriodModule from 'store/modules/enrollment/enrollmentPeriodModule';
import GroupModule from 'store/modules/group/groupModule';
import { InviteEmployersDelegate } from 'store/modules/group/ui-stores/inviteEmployersDelegate';
import { ChecklistCompletionStatus } from '@insurancemenu/imenu-components-lib/dist/types';
import { redirectToRoute } from 'routes/redirectToRoute';
import { QuoteFlowDomainParams } from './quoteFlowDelegate';
import { QUOTE_CHECKLIST_MAPPING } from './checklistMapping';

interface SidebarChecklistStep {
  label: string;
  completionStatus: ChecklistCompletionStatus;
  onClick: () => void;
  pageId: RouteV2Id;
}

export class QuoteFlowSidebarDelegate {
  private _domainData: QuoteFlowDomainParams;
  private _groupModule: GroupModule;
  private _enrollmentPeriodModule: EnrollmentPeriodModule;
  public inviteEmployersDelegate: InviteEmployersDelegate;

  public get groupId(): string {
    return this._groupModule.group.id;
  }

  public get checklistSteps(): SidebarChecklistStep[] {
    if (this._enrollmentPeriodModule.enrollmentProposalData === null) return [];

    const proposalChecklist = this._enrollmentPeriodModule.quoteProposalChecklistData(this._domainData.cartId);

    if (!proposalChecklist) {
      throw new Error(`No proposal with id: ${this._domainData.cartId}!`);
    }

    return proposalChecklist.checklistOptions.map((step) => {
      const pageId = QUOTE_CHECKLIST_MAPPING[step.card] as QuoteRouteV2Id;
      const page = QUOTE_ROUTES[pageId];
      // Capture primitives here (inside reactive derivation) so click handlers do not
      // read observables later outside observer/reaction — avoids MobX 6 strict warnings.
      const { groupId, periodId, cartId } = this._domainData;
      return {
        label: page.title,
        completionStatus: step.completionStatus,
        onClick: (): void => {
          redirectToRoute(pageId, { groupId, periodId, cartId });
        },
        pageId,
      };
    });
  }

  public get isFlowDataLoading(): boolean {
    return this._groupModule.isLoading || this._enrollmentPeriodModule.isLoading;
  }

  constructor(
    groupModule: GroupModule,
    enrollmentPeriodModule: EnrollmentPeriodModule,
    domainData: QuoteFlowDomainParams,
  ) {
    this._groupModule = groupModule;
    this._enrollmentPeriodModule = enrollmentPeriodModule;
    this._domainData = domainData;
    this.inviteEmployersDelegate = new InviteEmployersDelegate({ groupModule });

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
